<template>
  <div class="page-container">
    <el-card>
      <div slot="header">
        <span>电话换号申请</span>
      </div>
      <el-table :data="list" v-loading="loading" style="width: 100%">
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column prop="userId" label="用户ID" width="100"></el-table-column>
        <el-table-column prop="oldPhone" label="旧手机号"></el-table-column>
        <el-table-column prop="newPhone" label="新手机号"></el-table-column>
        <el-table-column prop="status" label="状态" width="100"></el-table-column>
        <el-table-column prop="createdAt" label="申请时间" width="180"></el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status === 'PENDING'" size="mini" type="success" @click="approve(scope.row.id, 1)">通过</el-button>
            <el-button v-if="scope.row.status === 'PENDING'" size="mini" type="danger" @click="approve(scope.row.id, 0)">拒绝</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { vpost } from "@/util/post";

export default {
  name: "PhoneReqManage",
  data() {
    return { list: [], loading: false };
  },
  mounted() { this.fetchData(); },
  methods: {
    fetchData() {
      this.loading = true;
      vpost("/admin/phone/listPhoneReq").then(res => {
        if (res.code === 200) this.list = res.data || [];
      }).finally(() => this.loading = false);
    },
    approve(id, status) {
      vpost("/admin/phone/approve", { id, status }).then(res => {
        if (res.code === 200) {
          this.$message.success("操作成功");
          this.fetchData();
        }
      });
    }
  }
};
</script>
